import { faFileInvoice, faTruckFast } from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export type AddressSide = 'Bill-To' | 'Ship-To';

/**
 * Per-side identity: icon, plain-language purpose, and the accent classes.
 *
 * Colour is never the only signal — the icon and the purpose line say the same
 * thing independently, so the two sides stay distinguishable in greyscale and
 * for a colour-blind operator.
 */
interface SideStyle {
  icon: IconDefinition;
  purpose: string;
  /** Heading + Edit button text colour. */
  text: string;
  /** Card border. */
  border: string;
  /** Card header strip fill. */
  headerBg: string;
  /** Focus/hover border on the dropdown trigger. */
  hoverBorder: string;
}

export const ADDRESS_SIDES: Record<AddressSide, SideStyle> = {
  'Bill-To': {
    icon: faFileInvoice,
    purpose: 'Invoice goes here',
    text: 'text-primary',
    border: 'border-primary/40',
    headerBg: 'bg-primary/10',
    hoverBorder: 'hover:border-primary',
  },
  'Ship-To': {
    icon: faTruckFast,
    purpose: 'Equipment returns here',
    text: 'text-blue-700 dark:text-blue-400',
    border: 'border-blue-500/40',
    headerBg: 'bg-blue-500/10',
    hoverBorder: 'hover:border-blue-500',
  },
};

/** Only Bill-To carries a tax identity. */
export const showsGst = (side: AddressSide): boolean => side === 'Bill-To';
